import React, { useEffect } from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  FS_LOADER_FADE_TIME,
  MENUS_PERMISSION_MAP,
  NO_USER,
  USER_FIRST_LOGIN,
  USER_LOGGED,
} from "./Constants";
import FullPageLoading from "./FullPageLoading";
import App from "./App";
import utility from "./Utils";
import FirstLogin from "./FirstLogin";

const ProtectedRoute = () => {
  const [state, setState] = useState(0);
  const [token, setToken] = useState(null);
  const [fullPageLoadingMessage, setFullPageLoadingMessage] = useState("");

  const onFirstPasswordSave = async () => {
    let newToken = { ...token, last_login: new Date() };

    await utility.setToken(newToken);
    setToken(newToken);
    setState(USER_LOGGED);
  };

  const loadInit = async () => {
    // check if user is admin
    if (!token.client_id) {
      // show config loading screen
      setFullPageLoadingMessage(
        "Please wait while we are setting up configs and caching data for you..."
      );
      setState(0);
      setState(1);
    }
  };

  useEffect(() => {
    utility
      .getToken()
      .then(result => {
        setTimeout(() => {
          if (result && !result.last_login && result.client_type) {
            setState(USER_FIRST_LOGIN);
          } else {
            setState(result ? USER_LOGGED : NO_USER);
          }
          setToken(result);
        }, FS_LOADER_FADE_TIME);
      })
      .catch(error => {
        console.error(error);
        setState(NO_USER);
      });
  }, []);

  useEffect(() => {
    if (token) {
      loadInit();
    }
  }, [token]);

  let menuPermissions = [];
  let permissionMap = JSON.parse(JSON.stringify(MENUS_PERMISSION_MAP));
console.log(`permissionMap ver: ${permissionMap[32]}`);
  // if (token && !token.client_type) {
  if (token) {
    // build list of allowed menus based on permissions given
    let userPermissions = token.permissions;
    for (let i = 0; i < permissionMap.length; i++) {
      for (let j = 0; j < userPermissions?.length || 0; j++) {
        if (userPermissions[j] === permissionMap[i].permission) {
          menuPermissions.push(permissionMap[i]);
        }
      }
    }
    // loop on permitted menus and build submenu permission
    for (let i = 0; i < menuPermissions.length; i++) {
      // maintain separate list for permitted sub menus
      let permittedSubMenus = [];
      for (let j = 0; j < menuPermissions[i].subMenus.length; j++) {
        // check if the submenu exists in user permissions
        if (
          userPermissions.includes(menuPermissions[i].subMenus[j].permission)
        ) {
          permittedSubMenus.push(menuPermissions[i].subMenus[j]);
        }
      }
      // update the sub menus
      menuPermissions[i].subMenus = permittedSubMenus;
    }
  }

  switch (state) {
    case -1:
      return <Navigate to="/login" replace />;
    case 1:
      return <App token={token} menuPermissions={menuPermissions} />;
    case 2:
      return <FirstLogin token={token} onUpdate={onFirstPasswordSave} />;
    default:
      return <FullPageLoading message={fullPageLoadingMessage} />;
  }
};

export default ProtectedRoute;
